import React from 'react';

export function FrameIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_12_2142)">
        <path
          d="M3.33203 5.00016C3.33203 4.55814 3.50763 4.13421 3.82019 3.82165C4.13275 3.50909 4.55667 3.3335 4.9987 3.3335H14.9987C15.4407 3.3335 15.8646 3.50909 16.1772 3.82165C16.4898 4.13421 16.6654 4.55814 16.6654 5.00016V15.0002C16.6654 15.4422 16.4898 15.8661 16.1772 16.1787C15.8646 16.4912 15.4407 16.6668 14.9987 16.6668H4.9987C4.55667 16.6668 4.13275 16.4912 3.82019 16.1787C3.50763 15.8661 3.33203 15.4422 3.33203 15.0002V5.00016Z"
          stroke="#FEFEFE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M12.5 3.3335V16.6668" stroke="#FEFEFE" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="12.9102" y="3.5791" width="3.27734" height="12.6348" fill="#FEFEFE" />
      </g>
      <defs>
        <clipPath id="clip0_12_2142">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
